import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Container } from '../styles/styled';
import ForBanksImage from '../images/Bank.png';
import ForFintechsImage from '../images/wallers.png';
import ForDevelopersImage from '../images/developers.png';

const ForBanksWrapper = styled.section`
    padding: 80px 0;
    
    @media (max-width: 768px) {
        padding: 50px 0;
    }
    
    @media (max-width: 480px) {
        padding: 40px 0;
    }
    
    .content-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 40px;
        
        @media (max-width: 1024px) {
            gap: 30px;
        }
        
        @media (max-width: 768px) {
            flex-direction: column;
            gap: 30px;
        }
    }
    
    .text-content {
        flex: 1;
        
        @media (max-width: 768px) {
            width: 100%;
        }
        
        h2 {
            font-size: 36px;
            color: #002DFF;
            margin-bottom: 20px;
            
            @media (max-width: 768px) {
                font-size: 28px;
                margin-bottom: 18px;
            }
            
            @media (max-width: 480px) {
                font-size: 24px;
                margin-bottom: 15px;
            }
        }
        
        .buttons {
            display: flex;
            gap: 20px;
            margin-bottom: 20px;
            flex-wrap: wrap;
            
            @media (max-width: 768px) {
                gap: 12px;
                margin-bottom: 18px;
            }
            
            @media (max-width: 480px) {
                gap: 10px;
                margin-bottom: 15px;
            }
        }
        
        .btn {
            font-size: 13px;
            padding: 10px 10px;
            text-align: center;
            color: #002DFF;
            border-radius: 10px;
            border: 1px solid #002DFF;
            text-decoration: none;
            font-weight: 500;
            transition: background-color 0.3s ease, color 0.3s ease;
            white-space: nowrap;
            
            @media (max-width: 480px) {
                font-size: 12px;
                padding: 8px 12px;
                flex: 1 1 auto;
                min-width: fit-content;
            }
            
            &.active {
                background-color: #002DFF;
                color: #fff;
            }
            
            &:hover {
                background-color: #002DFF;
                color: #fff;
            }
        }
        
        p {
            font-size: 18px;
            font-weight: 700;
            color: #555;
            line-height: 1.6;
            
            @media (max-width: 768px) {
                font-size: 16px;
                line-height: 1.5;
            }
            
            @media (max-width: 480px) {
                font-size: 15px;
                font-weight: 600;
            }
        }
    }
    
    .image-content {
        flex: 1;
        
        @media (max-width: 768px) {
            width: 100%;
            display: flex;
            justify-content: center;
        }
        
        img {
            max-width: 100%;
            height: auto;
            border-radius: 10px;
            
            @media (max-width: 768px) {
                max-width: 90%;
            }
            
            @media (max-width: 480px) {
                max-width: 100%;
            }
        }
    }
`;

const DecorativeSpan = styled.span`
    background-color: #78FFD6;
    height: fit-content;
    border-radius: 8px;
    display: block;
    width: 140px;
    color: #78FFD6;
    font-size: 37px;
    margin-bottom: -45px;
    margin-left: -10px;
    
    @media (max-width: 768px) {
        width: 110px;
        font-size: 30px;
        margin-bottom: -35px;
    }
    
    @media (max-width: 480px) {
        width: 90px;
        font-size: 24px;
        margin-bottom: -28px;
        margin-left: -5px;
    }
`;

const ForBanks = () => {
    const { t } = useTranslation('common');
    const [activeTab, setActiveTab] = useState('banks');
    
    const tabs = ['banks', 'fintechs', 'developers'];
    
    const tabLabels = {
        banks: t('forBanks.tab.banks'),
        fintechs: t('forBanks.tab.fintechs'),
        developers: t('forBanks.tab.developers')
    };
    
    const contents = {
        banks: t('forBanks.content.banks'),
        fintechs: t('forBanks.content.fintechs'),
        developers: t('forBanks.content.developers')
    };
    
    const images = {
        banks: ForBanksImage,
        fintechs: ForFintechsImage,
        developers: ForDevelopersImage
    };
    
    const alts = {
        banks: t('forBanks.alt.banks'),
        fintechs: t('forBanks.alt.fintechs'),
        developers: t('forBanks.alt.developers')
    };
    
    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };
    
    return (
        <ForBanksWrapper id="for-banks">
            <Container>
                <div className="content-wrapper">
                    <div className="text-content">
                        <DecorativeSpan>S</DecorativeSpan>
                        <h2>{t('forBanks.title')}</h2>
                        <div className="buttons">
                            {tabs.map((tab) => (
                                <a
                                    key={tab}
                                    href="#"
                                    className={`btn ${activeTab === tab ? 'active' : ''}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleTabClick(tab);
                                    }}
                                >
                                    {tabLabels[tab]}
                                </a>
                            ))}
                        </div>
                        <p>{contents[activeTab]}</p>
                    </div>
                    <div className="image-content">
                        <img src={images[activeTab]} alt={alts[activeTab]} />
                    </div>
                </div>
            </Container>    
        </ForBanksWrapper>
    );
}

export default ForBanks;